import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { QuestionListComponent } from '@items/question-list/question-list.component';
import { ItemService } from '@services/item.service';
import { NotificationService } from '@services/notification.service';
import { QuestionService } from '@services/question.service';
import { WebErrorService } from '@services/webError.service';
// import { Editor } from 'ngx-editor';
import { Subscription } from 'rxjs';
import { GlobalToolbarConfig } from 'src/app/shared/addnewquestion';
import { CkeditorConfig, QuestionSubTypeIdEnum, QuestionTypeIdEnum } from 'src/app/shared/config/questions.config';
import { customValidationService } from 'src/app/shared/custom.validator';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { TranslateService } from '@ngx-translate/core';
import * as Editor from '../../../../assets/ckeditor';
import Adapter from '../ckeditorAdapter';
@Component({
  selector: 'app-items-survey-star-rating',
  templateUrl: './items-survey-star-rating.component.html',
  styleUrls: ['./items-survey-star-rating.component.scss']
})
export class ItemsSurveyStarRatingComponent implements OnInit {
  reuseProp = {
    questionuuId: 'questionuuId',
    questiondescription: 'questiondescription',
    description: 'description',
    tempOption: 'tempOption',
    options: 'options',
    correctPoints: 'correctPoints',
    itemId: 'itemId',
    penaltyPoints: 'penaltyPoints',
    minScoreIfAttempt: 'minScoreIfAttempt',
    scoringTypeExactMatch: 'scoringTypeExactMatch',
  }

  // @ViewChild(QuestionListComponent) child!: any;
  @Output() postCreated = new EventEmitter();
  itemId: any;
  surveyStarRatingForm: FormGroup;
  // optionEditor: Editor = new Editor();
  // questionEditor: Editor = new Editor();
  // editor: Editor = new Editor();
  isEditMode: boolean = false;
  isListMode: boolean = false;
  isQuestionAdded: boolean = false;
  validateQuestion: boolean = false;
  showOptions: boolean = false;
  questionId: string;
  display: boolean = false;
  optionToDelete: number[] = [];
  listDisplay = false;
  saveDisable: boolean = false;
  toolbar = GlobalToolbarConfig;
  displayQuestionType: boolean = false;
  private routerSubscription: Subscription;
  ckeditorConfig = CkeditorConfig;
  isCkeditorLoading: boolean = true;
  QuestionOrientation: any;
  //-------- CKEditor5 Version---------
  @ViewChild("myEditor") myEditor: any;
  public Editor: any = Editor;
  errorMessage;
  QuestionSubTypeIdEnum = QuestionSubTypeIdEnum;
  QuestionTypeIdEnum = QuestionTypeIdEnum;  public uploadedFileNames = [];
  QuestionImages = []
  optionImages = []
  imageId: number = 1;
  constructor(
    public questionService: QuestionService,
    public itemservice: ItemService,
    private notificationService: NotificationService,
    private routerstate: ActivatedRoute,
    private webErrorService: WebErrorService,
    public dialog: MatDialog,
    private router: Router,
    private translate: TranslateService) {

    this.questionId = sessionStorage.getItem(this.reuseProp.questionuuId);
    if (!this.questionId) {
      this.questionId = this.router.getCurrentNavigation()?.extras?.state?.questionId;
    }
    this.surveyStarRatingForm = new FormGroup({
      ansRenderCount: new FormControl(0),
      questionOrder: new FormControl(0),
      questionSubTypeId: new FormControl(QuestionSubTypeIdEnum.SurveyStarRating),
      questionTypeId: new FormControl(QuestionTypeIdEnum.SurveyStarRating),
      questiondisplayoptions: new FormControl('Horizontal'),
      active: new FormControl(true),
      autoScoring: new FormControl(false),
      allowCheckAnswer: new FormControl(false),
      shuffleOption: new FormControl(false),
      Ratinglow: new FormControl(""),
      Ratinghigh: new FormControl(""),
      [this.reuseProp.scoringTypeExactMatch]: new FormControl(false),
      [this.reuseProp.questiondescription]: new FormGroup({ description: new FormControl('', Validators.required), mediaURL: new FormControl([""]), file_name: new FormControl([""]), publicPoints: new FormControl(''), inLine:new FormControl(''), outLine: new FormControl('')  }),
      [this.reuseProp.itemId]: new FormControl(+(sessionStorage.getItem('itemId'))),
      [this.reuseProp.options]: new FormArray([new FormGroup({
        answerDescription: new FormGroup({ description: new FormControl("Star"), mediaURL: new FormControl(["string"]), file_name: new FormControl(''), publicPoints: new FormControl(''), inLine:new FormControl(''), outLine: new FormControl('')  }),
        optionId: new FormControl(3, [Validators.required, customValidationService.noWhitespaceValidator()]),
        arrangeOrder: new FormControl(0),
        id: new FormControl(0),
        Modified: new FormControl(false),
        file_name: new FormControl([''])
      })]),
      [this.reuseProp.correctPoints]: new FormControl(0),
      [this.reuseProp.penaltyPoints]: new FormControl(0),
      [this.reuseProp.minScoreIfAttempt]: new FormControl(0),
      [this.reuseProp.tempOption]: new FormControl(),
    });
    this.questionService.getQuestionOrientation().subscribe(o => {this.QuestionOrientation = o.data})
  }

  get optionObject() {
    return this.surveyStarRatingForm.get(this.reuseProp.options) as FormArray
  }

  onReady(editor) {
    // console.log(this.myEditor);
    // editor.ui
    //   .getEditableElement()
    //   .parentElement.insertBefore(
    //     editor.ui.view.toolbar.element,
    //     editor.ui.getEditableElement()
    //   );
    sessionStorage.setItem('ImageUploadFileSizeErr', 'false');
    sessionStorage.setItem('imageUploadErr', 'false');
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      const adapter = new Adapter(loader, editor.config, this.itemservice);
      this.errorMessage = ''
      adapter.upload().catch((error) => {
        if (error === '') {
          if (sessionStorage.getItem('ImageUploadFileSizeErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          }

          if (sessionStorage.getItem('imageUploadErr') == 'true') {
            this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          }
          // this.itemservice.imageSizeErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error');
          //   }
          // });
          // this.itemservice.imageUploadErr.subscribe(x => {
          //   if(x == true) {
          //     this.errorMessage = this.translate.instant('questions.typeOfQuestions.hotspotQuestion.error1');
          //     // this.itemservice.imageUploadErr.unsubscribe();
          //   }
          // });
        }
      });
      adapter.upload().then(res=>{
        this.uploadedFileNames.push(res.fileName)
        this.QuestionImages.push({"uniqueId": "#image" + this.imageId++ , "imageName": res.fileName, "base64": res.default})
      })
      return adapter;
    }
  }

  onClick(event) {
    if (this.errorMessage && event) this.errorMessage = false;
  }

  back() {
    this.postCreated.emit('false');
    this.display = true;
    // this.questionEditor.destroy();
  }
  ngOnInit(): void {
    this.routerSubscription = this.routerstate?.parent?.params?.subscribe((data) => {
      this.itemId = data.id;
      this.questionId = sessionStorage.getItem('questionuuId');
      if (this.questionId) {
        this.isEditMode = true;
        this.questionService.getQuestion(this.itemId, this.questionId).subscribe((resdata) => {
          this.surveyStarRatingForm.controls[this.reuseProp.questiondescription].setValue(resdata.data.questiondescription);
          if (resdata.data.options && resdata.data.options.length) {
            resdata.data.options.forEach((element: any) => {
              delete element.selected;
              delete element.answerValid;
              delete element.correctPoints;
              delete element.styleid;
              delete element.optionScores;
              element.Modified = true;
            })
          }
          this.surveyStarRatingForm.controls[this.reuseProp.options].setValue(resdata.data.options);
          this.surveyStarRatingForm.controls['Ratinglow'].patchValue(resdata.data.ratinglow);
          this.surveyStarRatingForm.controls['Ratinghigh'].patchValue(resdata.data.ratinghigh);
          this.surveyStarRatingForm.controls['questiondisplayoptions'].patchValue(resdata.data.questiondisplayoptions)
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error);
        });
      }
    });
  }

  validateEditorText(value: string): boolean {
    return value !== '<p></p>' && value !== '';
  }

  setAndUpdateControl(controlName: string, value: any): void {
    this.surveyStarRatingForm.get(controlName).patchValue(value);
    this.surveyStarRatingForm.get(controlName).updateValueAndValidity();
  }

  validateAndSetQuestion(): void {
    this.isQuestionAdded = this.validateEditorText(this.surveyStarRatingForm.controls[this.reuseProp.questiondescription].value[this.reuseProp.description]);
    this.validateQuestion = this.isQuestionAdded === false;
  }

  saveSurveyStarRatingQuestion() {
    this.surveyStarRatingForm.controls[this.reuseProp.scoringTypeExactMatch].setValue(JSON.parse(this.surveyStarRatingForm.controls[this.reuseProp.scoringTypeExactMatch].value));

    let question = this.surveyStarRatingForm.value.questiondescription['description'];
    let question1 = question;//.replace(/(<([^>]+)>)/ig, '').replace(/^\s+/g, '').replace(/&nbsp;/g,'').trim();
    if (question1.length == 0) {
      this.webErrorService.customErrors(this.translate.instant('questions.typeOfQuestions.multipleResponse.errMsg3'), true, 'warn')
      return;
    }

    this.surveyStarRatingForm.value.questiondescription['file_name'] = this.uploadedFileNames;

    if (this.QuestionImages.length > 0) {
      this.QuestionImages.forEach(ele => {

        question1 = question1.replace(ele.base64, ele.uniqueId)

        let startIndex = ele.base64.lastIndexOf('base64,');
        ele.base64 = ele.base64.substring(startIndex +7)
      })
    }
    this.surveyStarRatingForm.value.questiondescription['description'] = question1;
    this.surveyStarRatingForm.value.questionImages = this.QuestionImages;

    if (this.isEditMode) {
      const questionServiceUpdateSubscription: Subscription = this.questionService.updateQuestion(this.surveyStarRatingForm.value, this.itemId, this.questionId).subscribe(
        (resData) => {
          this.itemservice.editedGetItem(resData.data);
          this.notificationService.success(resData?.message);
          // this.itemservice.questionCountUpdate.next(true);
          // this.questionService.reloadList.next(true);
          this.isListMode = true;
          questionServiceUpdateSubscription.unsubscribe();
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
    } else {
      const questionServicePostSubscription: Subscription = this.questionService.addQuestion(this.surveyStarRatingForm.value, this.itemId).subscribe(
        (resData) => {
          this.isEditMode = true;
          this.notificationService.success(resData?.message);
          // this.itemservice.questionCountUpdate.next(true);
          // this.questionService.reloadList.next(true);
          this.isEditMode = true;
          this.isListMode = true;
          questionServicePostSubscription.unsubscribe();
        },
        (error) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
    }
  }

  onCkeditorReady() {
    this.isCkeditorLoading = false;
  }

  removeArrayItem(index: number, property: string): void {
    const dialogRef = this.dialog.open(DelMessageComponent, {
      data: {
        message: 'Are you sure you want to delete this ' + property.slice(0, -1) + '?',
        buttonText: {
          ok: 'Yes',
          cancel: 'No',
        },
      },
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.optionToDelete.push((<FormArray>this.surveyStarRatingForm.get(property)).at(index).value.optionId);
        (<FormArray>this.surveyStarRatingForm.get(property)).removeAt(index);
        this.surveyStarRatingForm.get(property).updateValueAndValidity();
      }
    })
  }
}
